import { SignInPage } from '@backstage/core-components';
import { gitlabAuthApiRef } from '@backstage/core-plugin-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint, SignInPageProps } from '@backstage/plugin-app-react';

const GITLAB = {
  id: 'gitlab-auth-provider',
  title: 'GitLab',
  message:
    'Entre con su cuenta de GitLab de Grupo Vanti. Si no tiene acceso, pídale a un Admin que lo dé de alta.',
  apiRef: gitlabAuthApiRef,
};

/** El único login es GitLab. */
const PaginaIngreso = (props: SignInPageProps) => (
  <SignInPage {...props} title="Vanti Arch" align="center" providers={[GITLAB]} />
);

const paginaIngreso = SignInPageBlueprint.make({
  params: {
    loader: async () => PaginaIngreso,
  },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [paginaIngreso],
});
